import getEnvironDomain from "./utils/getEnvironDomain";
import release from "./release";

function getEnvironment() {
  if (process.env.NODE_ENV === "development") return "staging";

  if (typeof window !== "undefined") {
    return /ati\.su/gi.test(window.location.hostname)
      ? "production"
      : "staging";
  }

  return "staging";
}

const currentDomain = getEnvironDomain();

class Logger {
  constructor() {
    try {
      if (
        process.env.NODE_ENV !== "development" &&
        window.Sentry &&
        window.Errno
      ) {
        this.errno = new window.Errno({
          appName: "header",
          dsn: `https://f777f678372d4afeb0964b43bbd7f918@s1.${currentDomain}/6`,
          release,
          environment: getEnvironment(),
          ignoreErrors: [
            "yaCounter51678 is not defined",
            "VK is not defined",
            "[object XMLHttpRequest]",
          ],
          sampleRate: 0.1,
        });
      }
    } catch {
      console.log("errno disabled!");
    }
  }

  showNotification = ({ text, traceId, delay, type }) => {
    if (!this.errno) return;

    this.errno.show({ text, traceId, delay, type });
  };

  error = (error, options) => {
    if (!this.errno) return;

    this.errno.captureException(error, options);
  };
}

export default new Logger();
